import { render, staticRenderFns } from "./UniverseInfoMenu.vue?vue&type=template&id=a143afb8&scoped=true&"
import script from "./UniverseInfoMenu.vue?vue&type=script&lang=js&"
export * from "./UniverseInfoMenu.vue?vue&type=script&lang=js&"
import style0 from "./UniverseInfoMenu.vue?vue&type=style&index=0&id=a143afb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a143afb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VFlex,VLayout,VTab,VTabItem,VTabs})
